// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_7t-0";
export var optionCard = "_7t-1";